import * as React from "react";
import { Box, MenuItem } from "@mui/material";
import { MainInput } from "../../app/components/Styles";

const MONTH_OPTIONS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const buildYearOptions = (centerYear = new Date().getFullYear()) => {
  const years = [];
  for (let y = centerYear - 3; y <= centerYear + 5; y += 1) {
    years.push(String(y));
  }
  return years;
};

/**
 * Mobile-friendly month picker (year + month selects).
 * Value format: YYYY-MM
 */
export const MonthYearSelect = ({
  value,
  onChange,
  disabled = false,
  minMonth = null,
  yearOptions = buildYearOptions(),
}) => {
  const [year, month] = value ? value.split("-") : ["", ""];

  const emit = (nextYear, nextMonth) => {
    if (!nextYear || !nextMonth) {
      onChange(null);
      return;
    }
    onChange(`${nextYear}-${nextMonth}`);
  };

  const isMonthDisabled = (candidateMonth) => {
    if (!minMonth || !year) return false;
    return `${year}-${candidateMonth}` < minMonth;
  };

  return (
    <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
      <MainInput
        select
        fullWidth
        label="Month"
        value={month || ""}
        onChange={(e) => emit(year || String(new Date().getFullYear()), e.target.value)}
        disabled={disabled}
        sx={{ flex: "1 1 140px", minWidth: 140 }}
        SelectProps={{
          native: false,
          MenuProps: {
            // Keep menu above MUI Modal / mobile keyboards
            disablePortal: false,
            style: { zIndex: 2000 },
          },
        }}
      >
        {MONTH_OPTIONS.map((opt) => (
          <MenuItem
            key={opt.value}
            value={opt.value}
            disabled={isMonthDisabled(opt.value)}
          >
            {opt.label}
          </MenuItem>
        ))}
      </MainInput>
      <MainInput
        select
        fullWidth
        label="Year"
        value={year || ""}
        onChange={(e) => emit(e.target.value, month || "01")}
        disabled={disabled}
        sx={{ flex: "1 1 110px", minWidth: 110 }}
        SelectProps={{
          native: false,
          MenuProps: {
            disablePortal: false,
            style: { zIndex: 2000 },
          },
        }}
      >
        {yearOptions.map((y) => (
          <MenuItem key={y} value={y} disabled={minMonth ? `${y}-12` < minMonth : false}>
            {y}
          </MenuItem>
        ))}
      </MainInput>
    </Box>
  );
};

export default MonthYearSelect;
